import React, { useEffect, useState } from 'react';
import { URL_TRAZER } from '../../constants/api_urls';

import QRCode from 'qrcode.react';
import { Modal } from 'carbon-components-react';
import { PDFDownloadLink } from '@react-pdf/renderer';
import { Button, CircularProgress } from '@material-ui/core';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import funcTranslateHelper from '../../i18next/funcTranslateHelper';
import GeneratePDF from './GeneratePDF';

const CertificateGenerator = (props) => {
  const { chaincode, hash, data } = props;

  const [error, setError] = useState(null);
  const [qrCodeDataUri, setQrCodeDataUri] = useState(null);

  useEffect(() => {
    if (data && !qrCodeDataUri) {
      const qrCodeCanvas = document.querySelector('canvas');
      const qrCode = qrCodeCanvas.toDataURL('image/jpg', 0.3);
      setQrCodeDataUri(qrCode);
    }
  }, [data, qrCodeDataUri]);

  if (error) {
    return (
      <Modal
        iconDescription='Close the modal'
        modalHeading={error}
        modalLabel='Something was wrong'
        open
        passiveModal
      />
    );
  }

  return (
    <div>
      <QRCode id='qrcode' value={`${URL_TRAZER}${chaincode}/${hash}`} size={500} style={{ display: 'none' }} />
      <PDFDownloadLink document={<GeneratePDF chaincode={chaincode} hash={hash} qr={qrCodeDataUri} data={data} />} fileName={`certificate-${hash}.pdf`}>
        {({ blob, url, loading, err }) => {
          if (err) setError(err);
          if (!loading) {
            return (
              <Button
                style={{
                  fontFamily: 'Helvetica',
                  fontSize: 14,
                  color: '#0F62FE',
                  letterSpacing: 0.16,
                  lineHeight: '18 px',
                  border: '1px solid #0F62FE',
                  borderRadius: 0,
                  marginTop: 32,
                  marginBottom: 35,
                  textTransform: 'none'
                }}
              >
                {funcTranslateHelper('Trazer.Success.downloadPDF')}
                <FontAwesomeIcon
                  icon={faDownload}
                  style={{
                    color: '#0F62FE',
                    width: 14,
                    height: 14,
                    marginLeft: 22.5,
                    marginRight: 14
                  }}
                />
              </Button>);
          } else {
            return (
              <Button
                disabled
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#0F62FE',
                  border: '1px solid #0F62FE',
                  borderRadius: 0,
                  marginTop: 32,
                  marginBottom: 35,
                  textTransform: 'none'
                }}
              >
                {funcTranslateHelper('Trazer.Success.downloadPDF')}
                <CircularProgress style={{
                  color: '#0F62FE',
                  width: 14,
                  height: 14,
                  marginLeft: 22.5,
                  marginRight: 14
                }}
                />
              </Button>

            );
          }
        }}
      </PDFDownloadLink>
    </div>
  );
};

export default CertificateGenerator;
